import { Breadcrumb, Timeline } from 'antd'
import React from 'react'
import { useState } from 'react'
import { ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon } from '../../../../asset'
import { t } from "i18next";
import style from './deliveryTypePage.module.css'
import { useDeliveryType } from './DeliveryTypePage.hooks';
import { useLocation, useNavigate } from "react-router-dom";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import { useEffect } from 'react';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import { ROUTES } from "../../../../constant/routeConstant";
import { useSelector } from 'react-redux';
import { permissionButton } from '../../../../util/Util';
import CustomDivider from '../../../../component/divider/CustomDivider';

export default function DeliveryTypeDetail() {

    const { state } = useLocation()
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.auth);
    

    const {
        deleteConfirmationModalOpen,
        userManagementOpen,
        setUserManagementOpen,
        detailDeliveryType,
        doGetDetailDeliveryType,
        convertTimestamp,
        convertToTime,
        deleteConfirmation,
        setDeleteConfirmationModalOpen,
        doDeleteDeliveryTypeFromDetail,
        toEditDeliveryType,
        doGetManagementHistoryList,
        managementHistoryList,
        isSupportMitraGro
    } = useDeliveryType()

    const backToDeliveryTypeList = () => {
        navigate(ROUTES.DELIVERY_TYPE.LIST)
    }

    useEffect(() => {
        doGetDetailDeliveryType(state.id)
        doGetManagementHistoryList(state.id)
    }, [])


    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeleteDeliveryTypeFromDetail()}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you Sure want to delete <strong>Delivery Type ID {detailDeliveryType?.delivery_type_id}?</strong></p>}
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Delivery Type`}
                menuLevel4={`Detail ${detailDeliveryType?.delivery_type}`}
            />

            <div className="flex items-center justify-between gap-[22px]">
                <div className="flex items-center gap-[22px]" onClick={() => backToDeliveryTypeList()}>
                    <img src={BackIcon} className='cursor-pointer' alt="back-icon" />
                    <h1 className='font-sans-bold text-2xl cursor-pointer' id='title'>{`${t("DELIVERY_TYPE_DETAIL:TITLE")} ${detailDeliveryType?.delivery_type}`}</h1>
                </div>

                <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
                    <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detailDeliveryType?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailDeliveryType?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detailDeliveryType?.updated_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailDeliveryType?.updated_at, true)}</strong></p>
                </div>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
                {/* <h3 className="font-roboto font-[500] mb-[16px] text-lg">{t("DELIVERY_TYPE_DETAIL:DELIVERY_TYPE_INFORMATION")}</h3> */}

                <CustomDivider
                                                      name={"Delivery Type Information"}
                                                    />
                <div className="flex flex-col gap-[40px]">
                    <div>
                      <div className="flex">
                        {/* line one */}
                        <div className="gap-[40px] mb-[24px]">
                        <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Support MitraGro")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {isSupportMitraGro ? "Support" : "Not Support"}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Description")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detailDeliveryType?.description ? detailDeliveryType?.description : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[16px]">
                          
                        <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Delivery Code")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detailDeliveryType?.delivery_code}
                            </h4>
                          </div>
                          
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Start Trip")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detailDeliveryType?.automatic_start_trip? "Automatic - "+detailDeliveryType?.start_trip_time: "Manual"}
                            </h4>
                          </div>
                          
                          </div>
                        <div className="gap-[40px] mb-[16px]">
                        <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Delivery Type")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detailDeliveryType?.delivery_type ? detailDeliveryType?.delivery_type : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                      </div>
                      </div>

                <div className="flex flex-col gap-[40px]">
                    <div>
                      {/* <h3 className="font-roboto font-[500] mb-[16px] text-lg mt-6">
                        {t("Cost Information")}
                      </h3> */}
                                                    <CustomDivider
                                                      name={"Cost Information"}
                                                    />
                      <div className="flex">
                        {/* line one */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Cost/Kg ")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              Rp. {detailDeliveryType?.price_weight}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Cost/Hours ")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              Rp. {detailDeliveryType?.price_time ? detailDeliveryType?.price_time : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[16px]">
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Cost/m ")}<sup>3</sup>
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              Rp. {detailDeliveryType?.price_volume ? detailDeliveryType?.price_volume : "-"}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Base Price ")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              Rp. {detailDeliveryType?.base_price ? detailDeliveryType?.base_price : "-"}
                            </h4>
                          </div>
                        </div>
                        <div className="gap-[40px] mb-[16px]">
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Cost/Km ")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              Rp. {detailDeliveryType?.price_distance ? detailDeliveryType?.price_distance : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>

           

            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className={
          permissionButton(permission, "update", "deliverytype", "setup")
            ? 
        "bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" : "hidden"} onClick={() => toEditDeliveryType(detailDeliveryType)} >
                    {t("DELIVERY_TYPE_DETAIL:EDIT_BUTTON")}
                </button>
                <button className={
          permissionButton(permission, "delete", "deliverytype", "setup")
            ? "border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" : "hidden"} onClick={() => deleteConfirmation(detailDeliveryType?.delivery_type_id, detailDeliveryType?.updated_at, detailDeliveryType?.delivery_type)}>
                    {t("DELIVERY_TYPE_DETAIL:DELETE_BUTTON")}
                </button>
            </div>


            <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
                <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
                    <img src={CloseIcon} alt="" />
                </button>

                <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
                <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detailDeliveryType?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailDeliveryType?.created_at)}</strong></p>


                <div className={style.timelineContainer}>
                    <Timeline>
                        {
                            managementHistoryList.map((item, index) => {
                                if (index === 0) {
                                    return (
                                        <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                                            <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                                                <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                                                <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                                                <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                                            </div>
                                        </Timeline.Item>
                                    )
                                } else {
                                    return (
                                        <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                                            <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                                                <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                                                <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                                                <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                                            </div>
                                        </Timeline.Item>
                                    )
                                }
                            })
                        }
                    </Timeline>
                </div>
            </aside>
        </div>
    )
}
